export default __webpack_public_path__ + "static/media/related_01.3f227d97.jpg";